import { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import Axios from "axios";
import ReactHtmlParser from 'react-html-parser';
import { URL_LIST_ALL } from "../../../configs/api";
import { jwtDecode } from "jwt-decode";

export default function XemBangHang() {
    const { user } = useSelector((state) => state.auth);
    const dispatch = useDispatch();
    const { id } = useParams();
    const [listCustomer, setListCustomer] = useState([]); // Dữ liệu gốc từ API
    const [filteredCustomers, setFilteredCustomers] = useState([]); // Dữ liệu đã được lọc để hiển thị
    const [detail, setDetail] = useState([]);
    const [STATUS_OPTIONS, SET_STATUS_OPTIONS] = useState([]);
    const [loading, setLoading] = useState(false);
    const [floors, setFloors] = useState([]); // Danh sách các tầng duy nhất
    const [activeFloor, setActiveFloor] = useState("all"); // Tầng đang được chọn
    const [searchTerm, setSearchTerm] = useState("");
    const [socket, setSocket] = useState(null);

    const limit = 1000000;

    const fetchCustomers = async () => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    "Content-Type": "application/json; charset=UTF-8",
                },
            };

            const response = await Axios.get(
                `${URL_LIST_ALL}banghang?duan_id=${id}&limit=${limit}`,
                config
            );

            if (response.data.status === "success") {
                const rawData = response.data.data || [];
                const sortedData = rawData.sort((a, b) => {
                    const compareLo = a.thuoclo.localeCompare(b.thuoclo);
                    if (compareLo !== 0) return compareLo;
                    return a.sotang - b.sotang;
                });
                setListCustomer(sortedData);
                const uniqueFloors = [...new Set(sortedData.map(item => item.sotang))];
                setFloors(uniqueFloors.sort((a, b) => a - b));
            } else {
                console.warn(response.data.message);
            }
        } catch (err) {
            console.error("Lỗi lấy danh sách khách hàng:", err);
        } finally {
            setLoading(false);
        }
    };
    const feetDuAn = async () => {
        setLoading(true);
        try {
            const config = {
                headers: {
                    Authorization: `Bearer ${user.access_token}`,
                    "Content-Type": "application/json; charset=UTF-8",
                },
            };

            const response = await Axios.get(
                `${URL_LIST_ALL}duan/${id}`,
                config
            );

            if (response.data.status === "success") {
                setDetail(response.data.data)
            } else {
                console.warn(response.data.message);
            }
        } catch (err) {
            console.error("Lỗi lấy danh sách khách hàng:", err);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (user?.access_token) {
            Axios.get(URL_LIST_ALL + "banghang_settings", user.config).then(async (res) => {
                if (res.data.status === "success") {
                    let new_list = [];
                    const data = res.data.data
                    data.forEach(item => {
                        new_list.push({
                            value: item.id,
                            label: item.title,
                            background_color: item.background_color,
                            text_color: item.text_color,
                            action: item.action
                        },)
                    });
                    SET_STATUS_OPTIONS(new_list);
                } else console.log(res.data.message);
            }).catch((err) => console.log(err));
        }
    }, [user]);

    useEffect(() => {
        if (user?.access_token) {
            fetchCustomers();
            feetDuAn();
        }
    }, [user]);

    useEffect(() => {
        let result = listCustomer;
        if (activeFloor !== 'all') {
            result = result.filter(item => item.sotang === activeFloor);
        }
        if (searchTerm.trim() !== '') {
            result = result.filter(item =>
                item.title.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }
        setFilteredCustomers(result);

    }, [activeFloor, searchTerm, listCustomer]);

    const handleFloorFilter = (floor) => {
        setActiveFloor(floor);
    };

    const getStatusLabel = (status) => {
        const option = STATUS_OPTIONS.find(opt => opt.value === status);
        return option?.label || "";
    };
    const getStatusColor = (status) => {
        const option = STATUS_OPTIONS.find(opt => opt.value === status);
        return { background_color: option?.background_color || "#FFF", text_color: option?.text_color || "#1F2020", action: option?.action || null };
    };
    const style_tr = (status) => {
        const status_group = getStatusColor(status)
        let rs = { backgroundColor: status_group.background_color, color: status_group.text_color }
        if (status_group.action == 'Hide') {
            rs.display = "none"
        }
        return rs
    }


    useEffect(() => {
        const connectWebSocket = () => {
            // setFlag(true)
            const socketInstance = new WebSocket('wss://crmsk.bhsgroup.vn');
            socketInstance.onopen = () => { };
            socketInstance.onmessage = (evt) => {
                if (evt.data) {
                    let data = evt.data
                    try {
                        data = jwtDecode(data)
                        if (data) {
                            if (data.channel && data.channel == 'bcrm') {
                                let sound = 0;
                                if (data.event == 'banghang') {
                                    sound = 0
                                    const datasend = data.data
                                    setListCustomer(prev =>
                                        prev.map(item =>
                                            item.id === datasend.id ? { ...item, ...datasend } : item
                                        )
                                    );
                                }

                            }
                        }
                    } catch (error) {
                    }
                }
            };
            socketInstance.onclose = (event) => {
                setTimeout(() => {
                    connectWebSocket();
                }, 1000);
            };
            setSocket(socketInstance);
        };
        if (!socket) {
            connectWebSocket();
        }
        return () => {
            if (socket) {
                socket.close();
            }
        };
    }, [socket]);

    return (
        <div className="body-content">
            <div className="container">
                <div className="w-100 rounded p-2 border shadow-sm body-content">
                    {detail &&
                        <div className="row">
                            <h4 className="col-12 mb-3 mt-3">{detail.title}</h4>
                            <div className="col-12 col-sm-4">
                                <img src={detail.thumbnail} />
                            </div>
                            <div className="col-12 col-sm-8">
                                {ReactHtmlParser(detail.description)}
                            </div>
                        </div>
                    }
                </div>
                <div className="w-100 mt-2 rounded p-2 border shadow-sm body-content">
                    <h5>Thông tin bảng hàng</h5>
                    {loading && <div className="d-flex justify-content-center"><div className="loader"></div></div>}

                    {!loading && (
                        <div>
                            {/* Khu vực chứa các bộ lọc */}
                            <div className="d-flex flex-wrap align-items-center btn-group-tang mb-1">
                                {/* Nút phân tầng */}
                                <div>
                                    <button
                                        className={`btn btn-sm m-1 ${activeFloor === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
                                        onClick={() => handleFloorFilter('all')}
                                    >
                                        Tất cả
                                    </button>
                                    {floors.map(floor => (
                                        <button
                                            key={floor}
                                            className={`btn btn-sm m-1 ${activeFloor === floor ? 'btn-primary' : 'btn-outline-primary'}`}
                                            onClick={() => handleFloorFilter(floor)}
                                        >
                                            Tầng {floor}
                                        </button>
                                    ))}
                                    <div className="form-group mb-0 ms-auto" style={{ width: '250px' }}>
                                        <input
                                            type="text"
                                            className="form-control height32"
                                            placeholder="Tìm theo mã căn..."
                                            value={searchTerm}
                                            onChange={(e) => setSearchTerm(e.target.value)}
                                        />
                                    </div>
                                </div>
                                {/* Ô tìm kiếm nhanh */}

                            </div>

                            {filteredCustomers.length > 0 ? (
                                <div className="table-scroll-wrapper">
                                    <table className="table table-bordered table-hover table-banghang">
                                        <thead>
                                            <tr>
                                                <th className="sticky-col">Stt</th>
                                                <th className="sticky-col-2">Mã căn</th>
                                                <th className="w-80">Tòa/Lô</th>
                                                <th className="w-80">Tầng</th>
                                                <th className="w-80">Phòng ngủ</th>
                                                <th className="w-80">Phòng khách</th>
                                                <th className="w-80">Phòng WC</th>
                                                <th className="w-90">Hướng nhà</th>
                                                <th className="w-90">Diện tích</th>
                                                <th className="w-120">Giá bán</th>
                                                <th className="w-120">Đơn giá</th>
                                                <th className="w-90">Trạng thái</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {filteredCustomers.map((item, key) => (
                                                <tr key={item.id} style={style_tr(item.status)}>
                                                    <td className="sticky-col" style={style_tr(item.status)}>{key + 1}</td>
                                                    <td className="sticky-col-2" style={style_tr(item.status)}>
                                                        <strong>{item.title}</strong>
                                                    </td>
                                                    <td>{item.thuoclo}</td>
                                                    <td>{item.sotang}</td>
                                                    <td>{item.sophongngu}</td>
                                                    <td>{item.sophongkhach}</td>
                                                    <td>{item.sowc}</td>
                                                    <td>{item.huong}</td>
                                                    <td>{item.dientich}</td>
                                                    <td>{item.giaban ? item.giaban.toLocaleString('vi-VN') : null}</td>
                                                    <td>{item.giacoc ? item.giacoc.toLocaleString('vi-VN') : null}</td>
                                                    <td>
                                                        {getStatusLabel(item.status)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            ) : (
                                <h4 className="w-100 text-center mt-3">Không tìm thấy dữ liệu khớp với bộ lọc</h4>
                            )}
                        </div>
                    )}
                </div>
            </div>

        </div>
    );
}
